export const LOCAL_STORAGE_CONSTANT = {
    USER_DETAILS: 'currentUser',
    TOKEN: 'token'
};